import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useDispatch } from 'react-redux';

import Button from '@material-ui/core/Button';

import { Progress, Text, Avatar, NextIcon } from '../index';

import { StyledHospitalCard } from './style';

import { alertError, setStrapiToken } from '../../redux/stateActions';
import { fetchUser } from '../../redux/userAction';

import { GET_USER } from '../../services';

const SelectHospital = ({ data: { jwt, id, role, session } }) => {
    const dispatch = useDispatch();

    const [items, setItems] = useState([]);
    const [error, setError] = useState('');

    const handleGoBack = () => {
        localStorage.clear();
        // window.location.reload();
        // history.goBack();
    };

    useEffect(() => {
        if (session) {
            localStorage.setItem('session', session);
        }
    }, [session]);

    useEffect(() => {
        if (jwt) {
            localStorage.setItem('stp_to', jwt);
            dispatch(setStrapiToken(jwt));
        }
    }, [jwt]);

    // /*--------------- Get User ---------------*/
    const {
        loading: getUserLoading,
        error: getUserError,
        data: getUserData,
    } = useQuery(GET_USER, {
        variables: { id },
        skip: !id,
    });

    useEffect(() => {
        if (getUserError) {
            dispatch(alertError(`Cannot get user data: ${getUserError.message}`));
            handleGoBack();
        }

        if (getUserData) {
            const {
                user: { patients, staff },
            } = getUserData;

            if (role === 'Patient') {
                let newPatients = patients.filter((item) => item.hospital);

                if (_.isEmpty(newPatients)) {
                    setError(
                        `Cannot get Counseling Service data. account might be deactivated. please contact administrator.`
                    );
                    handleGoBack();
                }

                if (newPatients.length === 1) {
                    return handleSelectHospital(newPatients[0].hospital.id);
                }
                setItems(newPatients);
            } else {
                let newStaff = staff.filter((item) => item.hospital);

                if (_.isEmpty(newStaff)) {
                    setError(
                        `Cannot get Counseling Service data. account might be deactivated. please contact administrator.`
                    );
                    handleGoBack();
                }

                if (newStaff.length === 1) {
                    return handleSelectHospital(newStaff[0].hospital.id);
                }
                setItems(newStaff);
            }
        }
    }, [getUserError, getUserData]);

    const handleSelectHospital = (hospital) => {
        localStorage.setItem('hospital', hospital);
        dispatch(fetchUser(id, jwt, role, hospital));
    };

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                rowGap: '20px',
                position: 'relative',
            }}
        >
            {getUserLoading && <Progress />}

            {error && (
                <Text $color="red" style={{ textAlign: 'center' }}>
                    {error}
                </Text>
            )}

            {!_.isEmpty(items) &&
                items.map((item) => (
                    <Button
                        style={{ width: '100%', padding: 0, borderRadius: '16px' }}
                        key={item.hospital.id}
                        onClick={() => handleSelectHospital(item.hospital.id)}
                    >
                        <StyledHospitalCard>
                            <Avatar
                                $avatarSize="60px"
                                style={{ borderRadius: '50%' }}
                                src={item.hospital?.avatar?.url}
                                alt={item.hospital.name}
                            />
                            <Text $ellipsis style={{ textAlign: 'left' }}>
                                {item.hospital.name}
                            </Text>
                            <NextIcon fill="black" />
                        </StyledHospitalCard>
                    </Button>
                ))}
        </div>
    );
};

SelectHospital.propTypes = {
    data: PropTypes.object,
};

export default SelectHospital;
